import React from 'react';
import moment from 'moment';
import { BannerAction, Box } from '@trp-individual-investor-adv-svc/ii-prosp-components';
import '@trp-beacon-ui-kit/foundation/style-tokens/css/variables.css';
import '@trp-beacon-ui-kit/foundation/fonts/fonts.css';

import connectWithUserStore from '../../../reducers/connectWithUserStore';
import { closeModal } from '../../../Utils';

const scheduleApptClick = (link) => {
    window.open(link, '_blank');
    closeModal('banner-schedule-appt-modal');
};

const cancelClick = () => {
    closeModal('banner-schedule-appt-modal');
};

const ScheduleApptModal = connectWithUserStore(({ state }) => {
    const { adviceQuestionnaireLink, invitations } = state;

    const getCorrectLink =
        invitations && invitations.GeneralHelp
            ? invitations.GeneralHelp.invitation.reschedulingLink
            : adviceQuestionnaireLink;

    const appointmentDate =
        invitations &&
        invitations.GeneralHelp &&
        invitations.GeneralHelp.startTime &&
        moment(invitations.GeneralHelp.startTime).format('MMM D, YYYY');

    const appointmentTime =
        invitations &&
        invitations.GeneralHelp &&
        invitations.GeneralHelp.startTime &&
        moment(invitations.GeneralHelp.startTime).format('h:mm A');

    const title = appointmentTime ? 'Appointment scheduled' : 'Schedule an appointment';

    const getInternalText = () => {
        if (invitations?.GeneralHelp) {
            return (
                <Box>
                    <Box>You&apos;re scheduled to meet:</Box>
                    {invitations?.GeneralHelp?.owner} on {appointmentDate} at {appointmentTime}
                </Box>
            );
        }
        return 'Our advisors will work with you closely to help you reach your financial goals.';
    };

    return (
        <BannerAction
            id={'banner-schedule-appt'}
            title={title}
            text={getInternalText()}
            leftButtonText={'Cancel'}
            rightButtonText={invitations?.GeneralHelp ? 'Reschedule' : 'Schedule Now'}
            loadingTitle={'Scheduling an Appointment...'}
            loadingText={'One moment while we schedule an appointment...'}
            createClick={() => scheduleApptClick(getCorrectLink)}
            cancelClick={cancelClick}
        />
    );
});

export default ScheduleApptModal;
